import React, { Component } from 'react';
import config from "../config.json";

class GirisSayfa extends Component {


    state = {
        message: ''
    }

    componentDidMount() {
        document.title = "Altınkaynak Personel Sistemi - Giriş"

        if (localStorage) {
            localStorage.removeItem("user");
        }
    }

    componentWillUnmount() {
    }


    // API hatalari `error` alaninda doner; bilinen Ingilizce mesajlar Turkce gosterilir.
    // 429 (art arda hatali deneme) mesaji API'den zaten Turkce gelir.
    loginErrorMessage = (status, data) => {
        const error = data && (data.error || data.message);
        const known = {
            'Invalid credentials': 'Kullanıcı adı veya şifre hatalı.',
            'Account locked': 'Hesabınız kilitli. Lütfen yöneticinizle iletişime geçin.',
            'username and password are required': 'Kullanıcı adı ve şifre zorunludur.',
        };
        if (known[error]) return known[error];
        if (status === 429 && error) return error;
        return 'Giriş başarısız. Lütfen tekrar deneyin.';
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        this.setState({ message: '' });

        try {
            const response = await fetch(config.apiEndpoint + 'login', {
                method: 'POST',
                body: JSON.stringify({
                    "username": event.target[0].value,
                    "password": event.target[1].value,
                }),
                headers: { 'Content-Type': 'application/json' },
            });
            const data = await response.json().catch(() => ({}));

            // Eskiden `data.token !== ''` kontrolu hata cevabinda (token alani yok -> undefined) da true
            // donuyordu: hata govdesi "kullanici" olarak kaydedilip /Album'e yonlendiriliyordu.
            if (response.ok && data && data.token) {
                localStorage.setItem('user', JSON.stringify(data));
                window.location = '/Album';
                return;
            }
            this.setState({ message: this.loginErrorMessage(response.status, data) });
        } catch {
            this.setState({ message: 'Sunucuya bağlanılamadı. Lütfen tekrar deneyin.' });
        }
    };

    render() {
        return <React.Fragment>
            <div className="container-xxl">
                <div className="authentication-wrapper authentication-basic container-p-y">
                    <div className="authentication-inner">
                        <div className="card">
                            <div className="card-body">
                                <div className="app-brand justify-content-center">
                                    <h1 className="logo"><a href="/">Altınkaynak</a></h1>
                                </div>
                                <h4 className="mb-2">Altınkaynak Personel Sistemi</h4>
                                <p className="mb-4">Lütfen kullanıcı adınız ve şifrenizle giriş yapınız... </p>
                                <p className="alert-danger">{this.state.message}</p>
                                <form id="formAuthentication" className="mb-3" onSubmit={this.handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="username" className="form-label">KULLANICI ADI</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="username"
                                            name="username"
                                            placeholder="Kullanıcı adınızı girin"
                                            autoFocus
                                        />
                                    </div>
                                    <div className="mb-3 form-password-toggle">
                                        <div className="d-flex justify-content-between">
                                            <label className="form-label" htmlFor="password">ŞİFRE</label>
                                        </div>
                                        <div className="input-group input-group-merge">
                                            <input
                                                type="password"
                                                id="password"
                                                className="form-control"
                                                name="password"
                                                placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                                                aria-describedby="password"
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <button className="btn btn-primary d-grid w-100" type='submit'>Giriş</button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }
}

export default GirisSayfa;